import { NgModule } from '@angular/core';

import { DbmTableComponent } from '@app/shared/components/basic-components/dbm-table/dbm-table.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { DbmDropdownModule } from '@app/shared/components/basic-components/dbm-dropdown/dbm-dropdown.module';
import { DialogsModule } from '../../dialogs/dialogs.module';

@NgModule({
    imports: [MatSlideToggleModule, CommonModule, FormsModule, PipesModule, DbmDropdownModule, DialogsModule],
    declarations: [DbmTableComponent],
    entryComponents: [DbmTableComponent],
    exports: [DbmTableComponent]
})
export class DbmTableModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/basic-components/dbm-table/dbm-table.module.ts